import ViewPadrao from "../views/ViewPadrao";
import ItemList from "../views/ItemList";
import ItemCad from "../views/ItemCad";

export default {
  path: "item",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "item-list",
      component: ItemList
    },
    {
      path: "novo",
      name: "item-formulario",
      component: ItemCad
    },
    {
      path: "editar/:id",
      name: "item-formulario-editar",
      component: ItemCad
    }
  ]
};
